<template>
  <div v-if="segments && hasBullets" :class="['bullet-text-list', listClass]">
    <template v-for="(seg, i) in segments" :key="i">
      <div
        v-if="seg.type === 'plain'"
        class="bullet-text-plain"
        :class="textClass"
        :style="plainLineStyle(seg.text)"
      ><MentionText :text="seg.text" /></div>
      <div v-else-if="seg.type === 'numbered'" class="bullet-text-item">
        <span class="bullet-text-marker" aria-hidden="true">{{ seg.number }}.</span>
        <span class="bullet-text-content" :class="textClass"><MentionText :text="seg.text" /></span>
      </div>
      <div v-else class="bullet-text-item">
        <span class="bullet-text-marker" aria-hidden="true">•</span>
        <span class="bullet-text-content" :class="textClass"><MentionText :text="seg.text" /></span>
      </div>
    </template>
  </div>
  <span v-else :class="textClass" :style="plainStyle"><MentionText :text="displayFallback" /></span>
</template>

<script>
import { parseMixedContent, segmentIsListItem } from "@/utils/bulletText";
import MentionText from "@/components/MentionText.vue";

export default {
  name: "BulletText",
  components: { MentionText },
  props: {
    text: { type: [String, Number], default: "" },
    listClass: { type: String, default: "mb-0" },
    textClass: { type: String, default: "" },
    fallback: { type: String, default: "--" },
    preserveBreaks: { type: Boolean, default: true },
  },
  computed: {
    segments() {
      return parseMixedContent(this.text);
    },
    hasBullets() {
      return this.segments?.some(segmentIsListItem) ?? false;
    },
    displayFallback() {
      const t = this.text != null ? String(this.text).trim() : "";
      return t || this.fallback;
    },
    plainStyle() {
      if (!this.preserveBreaks) return undefined;
      const t = this.text != null ? String(this.text) : "";
      return t.includes("\n") ? { whiteSpace: "pre-wrap" } : undefined;
    },
  },
  methods: {
    plainLineStyle(text) {
      return text ? undefined : { minHeight: "1.45em" };
    },
  },
};
</script>

<style>
.bullet-text-list {
  margin: 0.15rem 0 0;
  padding: 0;
}

.bullet-text-plain {
  margin-bottom: 0.2rem;
  font-size: inherit;
  line-height: 1.45;
  word-break: break-word;
  white-space: pre-wrap;
}

.bullet-text-plain:last-child {
  margin-bottom: 0;
}

.bullet-text-item {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin-bottom: 0.2rem;
  font-size: inherit;
  line-height: 1.45;
}

.bullet-text-item:last-child {
  margin-bottom: 0;
}

.bullet-text-marker {
  flex-shrink: 0;
  color: #67748e;
  font-weight: 700;
  line-height: 1.45;
}

.bullet-text-content {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}
</style>
